import type { CompetitionPoolDetailed, UpdateCompetitionPoolRequest } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

export function updateCompetitionPoolDetails(
  competitionId: string,
  stageId: string,
  poolId: string,
  formData: UpdateCompetitionPoolRequest
): Promise<CompetitionPoolDetailed> {
  return requestApiJsonOrThrow<CompetitionPoolDetailed>(
    `admin/competitions/${competitionId}/competition-stages/${stageId}/competition-pools/${poolId}`,
    {
      method: 'PATCH',
      body: formData,
    }
  )
}
